import React from 'react';

import SimpleEditor from './SimpleEditor';

export default function CountedSimpleEditor({ uid, content, maxLength = null, handleChange = (e, content)=>{}, ...props }) {
    
    const [state, setState] = React.useState({
        currentLength: content.length,
    });

    const lengthError = maxLength !== null && state.currentLength > maxLength

    function _handleChange(e, content) {
        const newState = {
            ...state,
            currentLength: content.length,
        };
        setState(newState);

        handleChange(e, content);
    }
    
    return (
        <>
            <SimpleEditor content={content} handleChange={_handleChange} maxLength={maxLength} {...props} />
            <div style={{color: lengthError ? "red" : "inherit"}}>
                <span>{state.currentLength}</span>{
                    maxLength == null ? "" : (
                        <><span>/</span><span>{maxLength}</span></>
                    )
                }
            </div>
        </>
    );
}